import { Classes, Styles } from "jss";
import { createUseStyles } from "react-jss";
import { ThemeItem } from "../../theme";
import { HomeProps } from "./desktop";

export type HomeClassNames =
  | "mainSection"
  | "container"
  | "mainContainer"
  | "mainWrapper"
  | "mainContentBox"
  | "mainContentTitle"
  | "mainContentTitleSuperpay"
  | "mainContentDesc"
  | "mainImageBox"
  | "mainImgeCard"
  | "mainImgeMobile"
  | "mainContentStartedBox"
  | "mainContentStartedBtn"
  | "mainContentNoticeText"
  | "formControl"
  | "mainContentNoticeBox"
  | "mainContentAreaCodeBox"
  | "mainContentAreaCode"
  | "swiperSlideImage"
  | "swiperSlideText"
  | "swiperSlide"
  | "swiperContainer"
  | "circuleIcon"
  | "arrowRightIcon"
  | "getAppLabel"
  | "mainImgeMobileShadow"
  | "mainImgeMobileShadowMoile"
  | "backToTopPage"
  | "divider"
  | "spContentFaqTitle"
  | "spContentFaqList";

export type HomeClasses = Classes<HomeClassNames>;
export type HomeStyles = Styles<HomeClassNames>;
export type HomeStylesProps = HomeProps;

const getStyles: (theme: ThemeItem) => HomeStyles = (theme: ThemeItem) => ({
  container: { width: 960, maxWidth: "100%", margin: "0 auto" },
  divider: ({ width, breakpoint }) => ({
    // width: width <= breakpoint ? "5px" : "20px",
    // height: width <= breakpoint ? "5px" : "",
  }),
  backToTopPage: {
    position: "fixed",
    bottom: 30,
    right: 35,
    background: "white",
    border: "solid 0",
    boxShadow: "0 2px 5px #9a9a9a",
    borderRadius: 9,
    padding: [18, 20],
    zIndex: 999,
    cursor: "pointer",
    outline: "none",
    transition: ".4s all",
    // display: "none",
    "&:hover": {
      background: "#efefef",
    },
  },
  mainSection: { background: "#e3e3e3", paddingTop: 80 },
  mainContainer: { width: 1200, maxWidth: "100%", margin: "0 auto" },
  mainWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  arrowRightIcon: {},
  "@keyframes fadeIn": {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  mainImgeMobileShadow: ({ shadowMobileImageLoaded }) => ({
    width: 440,
    display: shadowMobileImageLoaded ? "block" : "none",
    "mix-blend-mode": "multiply",
    opacity: 1,
    position: "absolute",
    left: 0,
    bottom: 0,
    top: 75,
    right: 0,
    animation: "$fadeIn 1s",
  }),
  mainImgeMobileShadowMoile: ({ shadowMobileImageLoaded }) => ({
    display: shadowMobileImageLoaded ? "block" : "none",
    animation: "$fadeIn 1s",
    opacity: 1,
    position: "absolute",
    left: 0,
    bottom: 0,
    top: 75,
    right: 0,
  }),

  "@media (max-width: 1224px)": {
    mainWrapper: { padding: "0 18px", paddingBottom: 30 },
    mainContentTitle: {
      maxWidth: "70% !important",
    },
    swiperSlideImage: { width: "240px !important" },
  },
  "@media (max-width: 600px)": {
    mainImgeMobile: {
      width: "280px !important",
      top: "60px !important",
    },
    mainImgeMobileShadowMoile: {
      width: "300px !important",
      "mix-blend-mode": "multiply",
    },
  },
  "@media (min-width: 768px)": {
    circuleIcon: { width: "400px !important", height: "auto" },
    mainImgeMobileShadowMoile: {
      width: "440px !important",
      "mix-blend-mode": "multiply",
    },
  },
  "@media (max-width: 992px)": {
    // mainImgeMobileShadowMoile: {
    //   width: "440px !important",
    //   "mix-blend-mode": "multiply",
    // },
    mainWrapper: {
      display: "flex",
      flexDirection: "column-reverse",
    },
    mainContentTitle: {
      maxWidth: "none !important",
      textAlign: "center",
      fontSize: "35px !important",
    },
    mainContentStartedBox: {
      flexDirection: "column",
      marginBottom: 20,
    },
    circuleIcon: { width: 300, height: "auto" },
    // mainImgeMobile: {
    //   width: "280px !important",
    //   top: "60px !important",
    // },

    swiperSlideImage: { width: "160px !important" },
    mainContentDesc: {
      textAlign: "center",
      maxWidth: "none !important",
      fontSize: "16px !important",
      padding: [0, 8],
    },
    mainImgeCard: {
      top: "115px !important",
      left: "-10px !important",
      width: "175px !important",
    },
    arrowRightIcon: {
      // display: "none",
    },
    swiperSlide: {
      borderRight: "none !important",
    },
    swiperSlideText: { lineHeight: 1.4 },
    mainContentNoticeBox: { justifyContent: "center", marginBottom: 25 },
    mainContentBox: {
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
    },
    mainContentStartedBtn: {
      marginLeft: "none !important",
      marginTop: 25,
      padding: "14px 44px 12px 44px !important",
    },
    mainContentAreaCodeBox: {
      marginRight: "0 !important",
      marginBottom: 25,
      borderBottom: "solid 1px white !important",
    },
    formControl: { borderBottom: "solid 1px white !important" },
    swiperContainer: { marginTop: "40px !important" },
  },

  mainContentBox: {},
  mainContentTitle: {
    color: "#1b1464",
    fontSize: 52,
    fontWeight: 500,
    maxWidth: "70%",
    lineHeight: 1.2,
  },
  mainContentTitleSuperpay: {
    fontWeight: 300,
  },
  mainContentDesc: {
    color: "#25262c",
    fontSize: 22,
    fontWeight: 300,
    maxWidth: "55%",
    lineHeight: "1.3",
    marginTop: 12,
  },
  mainImageBox: { position: "relative" },
  mainImgeCard: { position: "absolute", left: "-65px", top: 190, width: 185 },
  mainImgeMobile: {
    opacity: 1,
    width: 400,
    position: "absolute",
    left: 0,
    bottom: 0,
    top: 75,
    right: 0,
  },
  mainContentStartedBox: {
    display: "inline-flex",
    alignItems: "center",
    marginTop: 15,
  },
  mainContentStartedBtn: {
    padding: [14, 14, 12, 14],
    background: "#c92941",
    fontSize: 16,
    borderRadius: 10,
    fontWeight: 500,
    color: "white",
    marginLeft: 20,
    marginBottom: 5,
    transition: ".3s all",
    "&::": {
      background: "#c51f38",
      boxShadow: "0 0px 6px #c51f38",
    },
  },
  mainContentNoticeBox: {
    display: "flex",
    alignItems: "center",
    marginTop: 35,
  },
  formControl: {
    transition: "0.25s border ease-in-out",
    borderRadius: 0,
    outline: "none",
    boxShadow: "none",
    background: "transparent",
    color: "black",
    border: 0,
    borderBottom: "2px solid white",
    fontSize: 20,
    paddingBottom: 5,
    paddingLeft: 35,
    "&:focus": {
      borderBottomColor: "#c92941",
    },
  },
  mainContentNoticeText: {
    color: "#6E6E6F",
    fontWeight: 500,
    marginLeft: 7,
    marginTop: 3,
  },
  mainContentAreaCodeBox: {
    display: "flex",
    alignItems: "center",
    marginRight: 20,
    borderBottom: "solid 2px white",
    paddingBottom: 8,
  },
  mainContentAreaCode: {
    color: "#25262c",
    fontSize: 18,
    fontWeight: 500,
    paddingTop: 2,
    margin: [0, 15, 0, 5],
  },
  circuleIcon: {},
  getAppLabel: ({ width, breakpoint }) => ({
    // textAlign: width <= breakpoint ? "center" : "",
    color: "#25262c",
    fontWeight: 500,
    marginTop: 50,
  }),
  swiperSlide: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderRight: "solid 1px #e4e4e4",
    "&:last-child": {
      borderRight: "none",
    },
  },
  swiperContainer: { marginTop: 80, marginBottom: 60, maxWidth: "96%" },
  swiperSlideImage: {
    width: 200,
    transition: ".3s all",
    "&:hover": {
      opacity: 0.8,
    },
  },
  swiperSlideText: { fontSize: 11, color: "rgba(110, 110, 111)" },
  spContentFaqTitle: {
    fontSize: 16,
    fontWeight: 500,
    color: "#25262c",
    marginTop: 40,
    marginBottom: 5,
  },
  spContentFaqList: {
    "& li": {
      fontSize: 14,
      fontWeight: 300,
      color: "#25262c",
      lineHeight: 1.56,
    },
  },
});

const useHomeStyles: (data?: HomeStylesProps) => HomeClasses = createUseStyles<
  ThemeItem,
  HomeClassNames
>(getStyles);

export default useHomeStyles;
